 
const setHooks=(db)=>
{ 
    db.users.hook("creating", function (primKey, obj, trans) 
    {
       obj.fulltext = getFulltextUsers(obj);
       obj.fulltextName= getFulltextName(obj);
       return
    });
    db.users.hook("updating", function (mods, primKey, obj, trans) 
    {
        const newObj={...obj,...mods}
        return { ...mods,fulltext: getFulltextUsers(obj), fulltextName: getFulltextName(newObj) }
           
    });
    db.cities.hook("creating", function (primKey, obj, trans) 
    {
       obj.fulltext = getFulltextPlz(obj);
       return
    });
    db.cities.hook("updating", function (mods, primKey, obj, trans) 
    {
        const newObj={...obj,...mods}
        return { ...mods,fulltext: getFulltextPlz(obj)}
           
    });
    
  
}

const getAllWords=(text)=>
{
    /// <param name="text" type="String"></param>
    var allWordsIncludingDups = text.split(/[\s\+\-,\(\)\\\/]/);
    var wordSet = allWordsIncludingDups.reduce(function (prev, current) {
        prev[current] = true;
        return prev;
    }, {});
    if(wordSet)
    {
        try
        {
            return Object.keys(wordSet).map(el=>
                   (el.toLocaleLowerCase('de-DE').replace(/[\(\)\-\+\s,\\\/]/g,''))

            ).filter(el=>el.length>2)
        }
        catch(e){ console.log('error',e,'in indexing, value:', text, wordSet)}
    }
    else
        return []
}
    
function getFulltextUsers(obj)
{
 


    let fulltext=[]
    if (typeof obj.Vorname == 'string' && obj.Vorname.length >2) 
    {
        fulltext=[...fulltext,...getAllWords(obj.Vorname)]
    }
    if (typeof obj.Nachname == 'string' && obj.Nachname.length >2) 
    {
        fulltext=[...fulltext,...getAllWords(obj.Nachname)]
    }
    if (typeof obj.email == 'string' && obj.email.length>2) 
    {
        fulltext=[...fulltext,obj.email]
    }
    if (typeof obj.Festnetz == 'string' && obj.Festnetz.length >2) 
    {
        fulltext=[...fulltext,obj.Festnetz]
    }
    if (typeof obj.mobil == 'string' && obj.mobil.length >2) 
    {
        fulltext=[...fulltext,obj.mobil]
    }
    return fulltext

}
function getFulltextName(obj)
{
    let fulltext=[]
    if (typeof obj.Vorname == 'string') 
    {
        fulltext=[...fulltext,...getAllWords(obj.Vorname)]
    }
    if (typeof obj.Nachname == 'string') 
    {
        fulltext=[...fulltext,...getAllWords(obj.Nachname)]
    }
    return fulltext

}

function getFulltextPlz(obj)
{
  


    let fulltext=[]
    if (typeof obj.Ort == 'string') 
    {
        fulltext=[...fulltext,...getAllWords(obj.Ort)]
    }
    if (typeof obj.PLZ == 'string') 
    {
        fulltext=[...fulltext,obj.PLZ]
    }
    return fulltext

}
export default setHooks
